import tenant from "../../api/tenant";
import fa from "element-ui/src/locale/lang/fa";

const state = {
    createTenantModalVisible: false,
    tenantSettingModalVisible: false,
    tenantInfo: {},
    tenantsList: [],
    tenantName: "",
    ossUploadObj: {},

    manageTenantList: {},
    manageTenantFilter: {},
    manageTenantLoading: false,

    tenantCopyLessonList: {},
    tenantCopyLessonFilter: {},
    tenantCopyLessonLoading: false
};

const getters = {};
const mutations = {
    setTenantState(state, payload) {
        for (let item in payload) {
            state[item] = payload[item];
        }
    },
    setData(state, {key, value}) {
        state[key] = value;
    },
    setTenantData(state, {key, value}) {
        state[key] = value;
    },
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async getTenantList({commit}, payload) {
        try {
            let parameter = {
                ...state.manageTenantFilter,
                ...payload
            };
            commit("setData", {key: "manageTenantLoading", value: true});
            const res = await tenant.getTenantList.getList(parameter);
            commit("setData", {key: "manageTenantList", value: res.data});
            return res;
        } catch (e) {
        } finally {
            commit("setData", {key: "manageTenantLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantCopyLessonList({commit}, payload) {
        try {
            let parameter = {
                ...state.tenantCopyLessonFilter,
                ...payload
            };
            commit("setData", {key: "tenantCopyLessonLoading", value: true});
            const res = await tenant.getTenantCopyLessonList.getList(parameter);
            commit("setData", {key: "tenantCopyLessonList", value: res.data});
            return res;
        } finally {
            commit("setData", {key: "tenantCopyLessonLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTenant({commit}, payload) {
        return await tenant.saveTenant(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async asyncTenantLesson({commit}, payload) {
        return await tenant.asyncTenantLesson(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async copyTestPaperToTenantId({commit}, payload) {
        return await tenant.copyTestPaperToTenantId(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getUserTenants({commit}, payload) {
        const res = await tenant.getUserTenants(payload);
        commit("setData", {key: "tenantsList", value: res.data});
        return res;
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantConfig({commit}) {
        const res = await tenant.getTenantConfig();
        console.log("getTenantConfig ", res)
        commit("setData", {key: "tenantInfo", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTenantConfig({commit}, payload) {
        return await tenant.saveTenantConfig(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async generalUploadUrl({commit}, payload) {
        const res = await tenant.generalUploadUrl(payload);
        commit("setData", {key: "ossUploadObj", value: res.data});
    },
    async getTenantInfo({}) {
        let res = await tenant.getTenantInfo();
        return res.data
    },
    async getCommercialPackage({}) {
        let res = await tenant.getCommercialPackage();
        return res.data
    },
    async getCommercialAssistClass({}) {
        let res = await tenant.getCommercialAssistClass();
        return res.data
    },
    async getProductInfo({}, payload) {
        let res = await tenant.getProductInfo(payload);
        return res.data
    },
    async getAssistClassTaskInfo({}, payload) {
        let res = await tenant.getAssistClassTaskInfo(payload);
        return res.data
    },
    async buyPackage({}, payload) {
        let res = await tenant.buyPackage(payload);
        return res.data
    },
    async buyProduct({}, payload) {
        let res = await tenant.buyProduct(payload);
        return res.data
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
